import { Bounce } from "react-toastify";
import { Status, TaggingStatus } from "../common/statusEnum";
import { TagTypeEnum } from "../enums/TagTypeEnum";
import {
  limeGreen,
  paleRed,
  paleViolet,
  paleYellow,
  silver,
} from "./StyleHelpers";

export const uniqueArray = (value: any, index: number, array: any) => {
  return array.indexOf(value) === index;
};

export const toHHMMSS = (value: any) => {
  const sec_num = parseInt(value, 10); // don't forget the second param
  let hours: any = Math.floor(sec_num / 3600);
  let minutes: any = Math.floor((sec_num - hours * 3600) / 60);
  let seconds: any = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  return hours + ":" + minutes + ":" + seconds;
};

export const isTextNeedsEllipsis = (text: string) => {
  return text.length >= 22;
};

export const ellipsisText = (text: string) => {
  if (isTextNeedsEllipsis(text)) return `${text.substring(0, 22)}...`;

  return text;
};

export const toPercentage = (value: any) => {
  return (parseFloat(value) * 100).toFixed(2);
};

export const padTo2Digits = (num: any) => num.toString().padStart(2, "0");

export const convertTimeString = (value: any) => {
  const timeSplit = value.split(":");
  let hours: any = padTo2Digits(parseInt(timeSplit[0]));
  let minutes: any = padTo2Digits(parseInt(timeSplit[1]));
  let seconds: any = padTo2Digits(Math.floor(timeSplit[2]));

  return hours + ":" + minutes + ":" + seconds;
};

export const mapStatus = (status: string) => {
  switch (status) {
    case TaggingStatus.processing:
    case TaggingStatus.uploaded:
      return Status.tagging;
    case TaggingStatus.processed:
      return Status.completed;
    default:
      return Status.error;
  }
};

export const convertToSeconds = (value: any) => {
  const timeSplit = value.split(":");
  let hours: any = parseInt(timeSplit[0]) * 3600;
  let minutes: any = parseInt(timeSplit[1]) * 60;
  let seconds: any = parseInt(timeSplit[2]);

  return hours + minutes + seconds;
};

export const handleError = ({ status, toast, errorMessage, onClose }: any) => {
  if (status === 401) {
    localStorage.clear();
    const message = "Unauthorized Access or Session Expired";
    toast.error(`${message}, Redirecting to Login Page`, {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
      onClose: () => {
        window.location.assign("/");
      },
    });

    return;
  }

  if (status === 403) {
    toast.error("You no longer have access to this folder or content.", {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });

    return;
  }

  if (status === 500) {
    const message = `An error occurred (code: ${status}). Please try again later.`;
    toast.error(message, {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });

    return;
  }

  if (!errorMessage) return;

  return toast.error(errorMessage, {
    position: "bottom-left",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    pauseOnFocusLoss: false,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    onClose: () => onClose,
  });
};

export const colorsCodes = (tagType: any) => {
  switch (tagType) {
    case TagTypeEnum.OCR:
      return limeGreen;
    case TagTypeEnum.label:
      return paleYellow;
    case TagTypeEnum.object:
      return paleRed;
    case TagTypeEnum.transcript:
      return paleViolet;
    case TagTypeEnum.general:
      return silver;
  }
};
